/** @type {string} this is the file path that is used by the logger. */
const filePath = 'helpers/homepage-helper/index';

// TODO: Is it worth it to convert this to the value that alloy returns so that we don't need this value?
// This is a string representation of each of the audiences so that it is a 
// single point of change if anything needs to get updated.
const BUSINESS_AUDIENCES = {
  DEFAULT_LOB: 'DEFAULT_LOB',
  STARTUP_MICRO_BUSINESS_CLIENT_LOB: 'STARTUP_MICRO_BUSINESS_CLIENT_LOB',
  STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB: 'STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB',
  ESTABLISHED_BUSINESS_LOB: 'ESTABLISHED_BUSINESS_LOB',
  MIDDLE_MARKET_LOB: 'MIDDLE_MARKET_LOB',
  COMPANIES_LOB: 'COMPANIES_LOB',
  LARGE_CORP_LOB: 'LARGE_CORP_LOB',
  INSTITUTIONS_LOB: 'INSTITUTIONS_LOB'
};
const ALLOY_VALUES = {
  DEFAULT_LOB: 'default',
  STARTUP_MICRO_BUSINESS_CLIENT_LOB: 'sbClients',
  STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB: 'sbProspects',
  ESTABLISHED_BUSINESS_LOB: 'midSize'
};
const QUERY_PARAM_VALUES = {
  STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB: 'SBPHP',
  STARTUP_MICRO_BUSINESS_CLIENT_LOB: 'SBCHP',
  ESTABLISHED_BUSINESS_LOB: 'MSBHP'
};

// This is the list of each of the business audiences to see if it exists
/** @type {string[]} */
const BUSINESS_AUDIENCES_LIST = [BUSINESS_AUDIENCES.DEFAULT_LOB, BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_CLIENT_LOB, BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB, BUSINESS_AUDIENCES.ESTABLISHED_BUSINESS_LOB];

// Alloy provides a different key for each value, so this functin will be used
// to convert them to the standardized value.
const ALLOY_CONVERSION_BUSINESS_AUDIENCE = {
  [ALLOY_VALUES.DEFAULT_LOB]: BUSINESS_AUDIENCES.DEFAULT_LOB,
  [ALLOY_VALUES.STARTUP_MICRO_BUSINESS_CLIENT_LOB]: BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_CLIENT_LOB,
  [ALLOY_VALUES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB]: BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB,
  [ALLOY_VALUES.ESTABLISHED_BUSINESS_LOB]: BUSINESS_AUDIENCES.ESTABLISHED_BUSINESS_LOB
};

// Convert to the response Alloy provides a different key for each value
const CONVERSION_TO_ALLOY_BUSINESS_AUDIENCE = {
  [BUSINESS_AUDIENCES.DEFAULT_LOB]: ALLOY_VALUES.DEFAULT_LOB,
  [BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_CLIENT_LOB]: ALLOY_VALUES.STARTUP_MICRO_BUSINESS_CLIENT_LOB,
  [BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB]: ALLOY_VALUES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB,
  [BUSINESS_AUDIENCES.ESTABLISHED_BUSINESS_LOB]: ALLOY_VALUES.ESTABLISHED_BUSINESS_LOB
};

// Convert the Query Parameter values to the proper response
const QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE = {
  [QUERY_PARAM_VALUES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB]: BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB,
  [QUERY_PARAM_VALUES.STARTUP_MICRO_BUSINESS_CLIENT_LOB]: BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_CLIENT_LOB,
  [QUERY_PARAM_VALUES.ESTABLISHED_BUSINESS_LOB]: BUSINESS_AUDIENCES.ESTABLISHED_BUSINESS_LOB
};

// Convert from Query Parameter values to the Alloy Response
const QUERY_PARAM_TO_ALLOY_CONVERSION_BUSINESS_AUDIENCE = {
  [ALLOY_VALUES.DEFAULT_LOB]: BUSINESS_AUDIENCES.DEFAULT_LOB,
  [ALLOY_VALUES.STARTUP_MICRO_BUSINESS_CLIENT_LOB]: BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_CLIENT_LOB,
  [ALLOY_VALUES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB]: BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB,
  [ALLOY_VALUES.ESTABLISHED_BUSINESS_LOB]: BUSINESS_AUDIENCES.ESTABLISHED_BUSINESS_LOB
};
const ALLOY_TO_QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE = {
  [ALLOY_VALUES.DEFAULT_LOB]: BUSINESS_AUDIENCES.DEFAULT_LOB,
  [ALLOY_VALUES.STARTUP_MICRO_BUSINESS_CLIENT_LOB]: BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_CLIENT_LOB,
  [ALLOY_VALUES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB]: BUSINESS_AUDIENCES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB,
  [ALLOY_VALUES.ESTABLISHED_BUSINESS_LOB]: BUSINESS_AUDIENCES.ESTABLISHED_BUSINESS_LOB
};
const EVENTS = {
  BUSINESS_HOMEPAGE_BUSINESS_SIZE_COMPLETE: "BUSINESS_HOMEPAGE_BUSINESS_SIZE_COMPLETE"
};

// TODO: Update all references to these
/**
 * @export
 * This is an export that will hold all constants used by the business homepage application.
 */
const CONSTANTS = {
  timeout: 3000,
  // This is the timeout of when we need to abort the alloy calls
  BUSINESS_AUDIENCES,
  BUSINESS_AUDIENCES_LIST,
  ALLOY_CONVERSION_BUSINESS_AUDIENCE,
  QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE,
  QUERY_PARAM_TO_ALLOY_CONVERSION_BUSINESS_AUDIENCE,
  CONVERSION_TO_ALLOY_BUSINESS_AUDIENCE,
  QUERY_PARAM_VALUES,
  ALLOY_TO_QUERY_PARAM_CONVERSION_BUSINESS_AUDIENCE,
  ALLOY_VALUES
};

// Local Functions
const checkForAndInvokeCallback = cb => {
  if (cb && typeof cb === 'function') {
    cb();
  } else {
    console.log(`[ERR] [6f1b1e0f-bcb9-4a2e-98f2-bf82505f4775] [${filePath}] No Callback was found or it is not a function: ${cb}`);
  }
};

// Exported Functions

/**
 * This is used when Alloy returns our JCR data, since we send them the JCR that
 * is using the image helper, we need to refactor it to the proper structure.
 * 
 * To do that we will expect to send them the string that has no-fingerprint so
 * so the value in Alloy response will look like:
 * {IMAGE||assets/images/site/homepage/business-homepage/product-and-article-picker-module/Client-SetUpAnAppointment-416x234.jpg||no-fingerprint}
 * 
 * @param {String} str image helper path from Alloy reponse
 * @returns {String}
 */
function alloyUpdateFromImageHelperToProperPath(str) {
  // Remove curly braces at beginning and end
  const clean = str.replace('{', '').replace('}', '');
  if (!clean) return str;
  // Break apart the helper into three components IMAGE, PATH, and FP(Fingerprint Flag)
  const [helper, path, fp] = clean.split('||');
  if (helper === 'IMAGE') {
    // Create array of all path parts
    const p = path.split('/');
    let result = '';
    if (!(p?.length || p[3])) {
      console.error('[ERR] [838464eb-6d68-4ac6-8eb6-2d5a90f1623b] Path link is not valid');
      return str;
    }
    result = `/${p[3]}/spa-assets/images/${p.join('-')}`;
    if (!result || result === '') return str;
    if (result.indexOf('undefined')) {
      result = result.split('undefined').join('');
    }
    return result;
  } else {
    return str;
  }
}

/**
 * 
 * @param {string} target This value is for the URL Query Parameter to convert 
 *                        it to the Alloy Response
 * @returns {string} The converted Alloy response based on the Query Parameter
 */
function businessQueryParamSelectorTransform(target) {
  let result = ALLOY_VALUES.DEFAULT_LOB;
  if (!target) result = ALLOY_VALUES.DEFAULT_LOB;
  switch (target) {
    case 'SBCHP':
      result = ALLOY_VALUES.STARTUP_MICRO_BUSINESS_CLIENT_LOB;
      break;
    case 'SBPHP':
      result = ALLOY_VALUES.STARTUP_MICRO_BUSINESS_NON_CLIENT_LOB;
      break;
    case 'MSBHP':
      result = ALLOY_VALUES.ESTABLISHED_BUSINESS_LOB;
      break;
    default:
      result = ALLOY_VALUES.DEFAULT_LOB;
      break;
  }
  return result;
}

/**
 * In this function we will attach a mouseup event of when the click on the tile and lift. When we
 * lift then we will go to the href of the CTA button that is assigned to the tile.
 * 
 * If the destroy boolean is true then we will remove the events, this is to make sure that we do
 * not duplicate events or leave events that are no longer needed.
 * 
 * @param {boolean} destroy determine if we are destroying the events or adding them.
 * @returns {void}
 */
function handleCardEvents(moduleEle, cards, destroy = false) {
  if (destroy) {
    cards.forEach(card => {
      card.removeEventListener('mouseup', e => {
        // For the targetted cards we have set a data- attribute so we will check to make sure we
        //   have the attribute so that we don't break.
        if (card.parentElement.dataset.proposition) {
          const proposition = JSON.parse(card.parentElement.dataset.proposition);
          alloy('sendEvent', {
            xdm: {
              // eventType denotes that a click was recorded
              eventType: 'decisioning.propositionInteract',
              _experience: {
                decisioning: {
                  propositions: [proposition]
                }
              }
            }
          });
        }

        // Prevent user from clicking the button directly.
        if (e.target.tagName.toLowerCase() === 'a') {
          e.preventDefault();
          return;
        }
        link.addEventListener('click', ev => {
          const triggered = link.getAttribute('ev-adClick-fired');
          if (triggered) {
            ev.preventDefault();
            return;
          } else {
            link.setAttribute('ev-adClick-fired', "true");
          }
        });
        // Dynamically click the button for consistency.
        link.click();
      });
    });
  } else {
    cards.forEach(card => {
      const link = card.querySelector('a');
      if (!link) return;
      const hasEv = link.hasAttribute('ev-has-prop');
      if (!hasEv) {
        card.addEventListener('mouseup', e => {
          // For the targetted cards we have set a data- attribute so we will check to make sure we
          //   have the attribute so that we don't break.
          if (card.parentElement.dataset.proposition) {
            const proposition = JSON.parse(card.parentElement.dataset.proposition);
            alloy('sendEvent', {
              xdm: {
                // eventType denotes that a click was recorded
                eventType: 'decisioning.propositionInteract',
                _experience: {
                  decisioning: {
                    propositions: [proposition]
                  }
                }
              }
            });
          }

          // Prevent user from clicking the button directly.
          if (e.target.tagName.toLowerCase() === 'a') {
            e.preventDefault();
            return;
          }
          link.addEventListener('click', ev => {
            const triggered = link.getAttribute('ev-adClick-fired');
            if (triggered) {
              ev.preventDefault();
              return;
            } else {
              link.setAttribute('ev-adClick-fired', "true");
            }
          });
          // Dynamically click the button for consistency.
          link.click();
        });
        link.setAttribute('ev-has-prop', "true");
      }
    });
  }
}

/**
 * @export
 * @method curve
 * @param {String} position position
 * @param {String} color color
 * @param {String} cssClass class
 * @returns {String} position
 */
function curve(position, color, cssClass) {
  const curvePosition = typeof position === 'string' && position ? position : 'both';
  const fillColor = typeof color === 'string' && color ? color : '#fff';
  const cssClassString = typeof cssClass === 'string' && cssClass ? cssClass : '';
  const positions = {
    top: `
        <svg focusable="false" class="curve-top ${cssClassString}" viewBox="0 0 1400 38" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
          <path d="M 0 38 L 0 0 L 1400 0.121 C 1346.561 0.952 1159.562 3.294 1106.153 3.435 C 1088.943 3.481 1071.736 3.614 1054.531 3.833 C 972.139 4.896 889.72 6.585 807.317 8.093 C 724.914 9.6 642.556 11.243 560.165 13.659 C 524.467 14.706 488.635 15.911 452.924 16.757 C 371.192 18.694 289.508 21.909 207.863 26.028 C 182.189 27.311 156.519 28.657 130.851 30.061" shape-rendering="geometricPrecision" style="fill:${fillColor};"/>
        </svg>
      `,
    bottom: `
        <svg focusable="false" class="curve-bottom ${cssClassString}" viewBox="0 0 1400 38" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
          <path d="M 48.179 34.027 C 77.767 32.124 107.361 30.31 136.961 28.583 C 246.195 22.388 355.479 17.949 464.832 14.561 C 574.238 11.173 683.657 8.376 793.092 6.173 C 902.831 3.852 1012.542 2.507 1122.299 1.45 C 1214.873 1.45 1307.424 0 1400 0 L 1400 37.953 C 1400 37.953 48.802 38.011 0 38" shape-rendering="geometricPrecision" style="fill: ${fillColor};"/>
        </svg>
      `
  };
  return position === 'both' ? positions.top + positions.bottom : positions[curvePosition];
}

/**
 * @exports
 * @method codeFriendly
 * @param {String} string string
 * @returns {String} string
 */
function codeFriendly(string) {
  return string.toLowerCase().replace(/<\/?[^>]*>/g, ' ').replace(/\s+/g, '-').replace(/(?:&\w+;|[^a-z0-9])/gi, '');
}

/**
 * Logger wrapper function that will handle submitting log to server and 
 * displaying log on console window
 * 
 * @param {Object} config Configuration Object
 * @param {String} config.level Severity of Log
 * @param {String} config.uuid Unique Identifier for log
 * @param {String} config.message Description of what needs to be logged
 * @param {String} config.path FilePath and potentially module that fired the log
 * @param {any} config.data Data that will be passed to the log
 * @param {Boolean} config.remote Boolean of if the log needs to be saved to server
 * @param {Boolean} config.browser Boolean of if the log needs to be sent to browser
 * 
 * @returns {void}
 */
function Logger(config) {
  const {
    level = 'LOG',
    uuid = '',
    message = 'Message for log',
    path = 'unknown/path',
    data = null,
    args = null,
    remote = false,
    browser = true
  } = config;
  const log_msg = `[${level}] [${uuid}] [${path}] ${message}
  ${args ? `Args: ${JSON.stringify(args)}` : ''}
  ${data ? `Data: ${JSON.stringify(data)}` : ''}`;
  if (browser) {
    console.log(log_msg);
  }
  if (remote) {
    console.log('Submit to server');
    // TODO:
  }
}
function evt_add_clickOutOfElement(element, cb) {
  document.addEventListener('click', event => {
    if (!element.contains(event.target)) {
      checkForAndInvokeCallback(cb);
    }
  });
}
function evt_destroy_clickOutOfElement(element, cb) {
  document.removeEventListener('click', event => {
    if (!element.contains(event.target)) {
      checkForAndInvokeCallback(cb);
    }
  });
}

/**
 * @exports
 * @method attrFriendly
 * @param {String} string string
 * @returns {String} string
 */
function attrFriendly(string) {
  return string.replace(/<\/?[^>]*>/g, ' ').replace('&nbsp;', ' ').replace(/\s+/gi, ' ');
}

// eslint-disable-next-line no-confusing-arrow
const isArray = (a, opts) => Array.isArray(a) ? opts.fn(undefined) : opts.inverse(undefined);

export { CONSTANTS, EVENTS, Logger, alloyUpdateFromImageHelperToProperPath, attrFriendly, businessQueryParamSelectorTransform, codeFriendly, curve, evt_add_clickOutOfElement, evt_destroy_clickOutOfElement, handleCardEvents, isArray };
